import React from 'react';
import { useTranslation } from 'react-i18next';
import ComingSoon from './ComingSoon';

const ActivityLogs = () => {
  const { t } = useTranslation();
  return <ComingSoon title={t('settings.menu.activityLogs')} />;
};

export default ActivityLogs;
